import React, { ReactElement, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { searchFilterTextAction } from './search-actions';

export default function SearchFilter(): ReactElement {
  const searchFilterText = useSelector(({ searchFilterText }: { searchFilterText: string }) => searchFilterText);
  const dispatch = useDispatch();
  const setSearchFilterText = useCallback((e) => dispatch(searchFilterTextAction(e.target.value)), [dispatch]);
  return (
    <div>
      <input type="text" placeholder="Sök" value={searchFilterText} onChange={setSearchFilterText} />
    </div>
  );
}
SearchFilter.displayName = 'SearchFilter';
